import {baseRequestService} from "../base.ts";

export const authReauthUserIdPost = (userId: number) => baseRequestService({
    url: `/auth/reauth/${userId}`,
    method: 'POST'
})